<template>
  <div>
    <div class="title">
      <h3>Critical Error encounted completing payment</h3>
    </div>
    <div class="msg">
      <p>
        This has likely occured due
        to circumstance beyond our control, including a network outage, or interuption,
        or other system failure while the payment process was being performed.
      </p>
      <p>
        Unfortunately given the nature of the issue the system cannot
        detemine if the failure occurred before or after the credit card was charged.
      </p>
      <p>
        We suggest you contact the site administrator to confirm if the transaction
        was successfully paid, <strong>Quoting Txn ID: </strong>{{ txn.txnid }}
      </p>.
      <p>
        Or alternatively, you can reload the current page,
        and if the payment was not completed,
        you can retry the payment.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'system-error',
  props: {
    details: {
      type: Error,
      required: true
    },
    txn: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang='scss' scoped>

</style>
